import { Logger } from "./log.js";
import { promisify } from "./promise.js";
const log = Logger("zeed:emitter");
export class Emitter {
    constructor() {
        this.debugEmitter = false;
        this.subscribers = {};
        this.subscribersOnAny = [];
    }
    async emit(event, ...args) {
        var _a;
        let ok = false;
        try {
            let subscribers = (this.subscribers[event] || []);
            this.debugEmitter &&
                log.debug("emit", (_a = this === null || this === void 0 ? void 0 : this.constructor) === null || _a === void 0 ? void 0 : _a.name, event, ...args, subscribers);
            this.subscribersOnAny.forEach((fn) => fn(event, ...args));
            if (subscribers.length > 0) {
                let all = subscribers.map((fn) => {
                    try {
                        return promisify(fn(...args));
                    }
                    catch (err) {
                        log.warn("emit warning:", err);
                    }
                });
                ok = true;
                await Promise.all(all);
            }
        }
        catch (err) {
            log.error("emit exception", err);
        }
        return ok;
    }
    onAny(fn) {
        this.subscribersOnAny.push(fn);
    }
    on(event, listener) {
        let subscribers = (this.subscribers[event] || []);
        subscribers.push(listener);
        this.subscribers[event] = subscribers;
        return {
            cleanup: () => {
                this.off(event, listener);
            },
        };
    }
    once(event, listener) {
        const onceListener = async (...args) => {
            this.off(event, onceListener);
            return await promisify(listener(...args));
        };
        this.on(event, onceListener);
    }
    off(event, listener) {
        // log("off", key)
        this.subscribers[event] = (this.subscribers[event] || []).filter((f) => listener && f !== listener);
        return this;
    }
    removeAllListeners(event) {
        this.subscribers = {};
        return this;
    }
}
// This can be used as a global messaging port to connect loose
// parts of your app
export const messages = new Emitter();
export function lazyListener(emitter, listenerKey) {
    const name = Math.round(Math.random() * 100);
    var events = [];
    var lazyResolve;
    const incoming = (key, obj) => {
        let ev = { key, obj };
        // debug(name, "  lazy push", ev)
        events.push(ev);
        lazyResolve && lazyResolve();
    };
    if (listenerKey) {
        if (emitter.on) {
            emitter.on(listenerKey, (obj) => {
                incoming(listenerKey, obj);
            });
        }
        else if (emitter.addEventListener) {
            emitter.addEventListener(listenerKey, (obj) => {
                incoming(listenerKey, obj);
            });
        }
        else {
            log.error(name, "Cannot listen to key");
        }
    }
    else {
        if (emitter.onAny) {
            emitter.onAny((key, obj) => {
                incoming(key, obj);
            });
        }
        else {
            log.error(name, "cannot listen to all for", emitter);
        }
    }
    let on = (key, skipUnmatched = true) => {
        return new Promise((resolve, reject) => {
            if (!key) {
                key = listenerKey;
                if (!key) {
                    if (events.length) {
                        // no key specified? just take the first one!
                        key = events[0].key;
                    }
                }
            }
            // debug(name, "lazy resolve on2", key, skipUnmatched, events)
            lazyResolve = () => {
                // debug(name, "lazy resolve", key, listenerKey, events)
                while (events.length > 0) {
                    let ev = events.shift();
                    // debug(name, "  lazy analyze", ev)
                    if (ev.key === key) {
                        lazyResolve = undefined;
                        resolve(ev.obj);
                    }
                    else {
                        if (skipUnmatched) {
                            log.warn(name, `Unhandled event ${key} with value: ${ev.obj}`);
                            continue;
                        }
                        reject(`Expected ${key}, but found ${ev.key} with value=${ev.obj}`);
                        log.error(name, `Unhandled event ${key} with value: ${ev.obj}`);
                    }
                    break;
                }
            };
            lazyResolve();
        });
    };
    return on;
}
//# sourceMappingURL=emitter.js.map